import { MetaText } from "@pathwright/blocks/src/shared"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Text from "@pathwright/ui/src/components/ui/Text"
import styled from "styled-components"
import {
  getSubmitPromptMessage,
  getUploaderMessage,
  normalizeHTML
} from "../utils"

const PromptMessageWrapper = styled.div`
  width: 100%;
  word-wrap: break-word;

  .MetaText > p {
    /* Ignore blocks styles for this text */
    color: #2a2e33;
  }
`

const SubmitPromptWrapper = styled.div`
  text-align: center;
  width: 100%;
  margin: 0 auto 2rem;

  .FilePickerUpload__instructions {
    color: #828282;
  }
`

const SubmitPrompt = ({ mediaType, submitPrompt }) => {
  const { t } = useTranslate()

  const heading = getUploaderMessage(mediaType, { t })

  const prompt = submitPrompt
    ? normalizeHTML(submitPrompt)
    : getSubmitPromptMessage(mediaType, t)

  return (
    <SubmitPromptWrapper>
      <Text.H3 style={{ marginBottom: "1rem" }}>{heading}</Text.H3>
      <PromptMessageWrapper>
        <MetaText html={prompt} />
      </PromptMessageWrapper>
    </SubmitPromptWrapper>
  )
}

export default SubmitPrompt
